import { useSyncExternalStore } from 'react';
import type { Membership } from '@walkkit/shared';
import { activeMembership, sessionStore, type StoredSession } from '../api';
import { queryClient } from './queryClient';

export function useSession(): StoredSession | null {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.get, sessionStore.get);
}

export function useMembership(): Membership | null {
  return activeMembership(useSession());
}

export function useIsOwner(): boolean {
  return useMembership()?.role === 'owner_admin';
}

export function isStaffRole(m: Membership | null | undefined): boolean {
  return m?.role === 'owner_admin' || m?.role === 'staff';
}

/** Memberships the dashboard can show (owner/staff). */
export function dashboardMemberships(s: StoredSession | null): Membership[] {
  return s?.user.memberships.filter(isStaffRole) ?? [];
}

export function switchBusiness(businessId: string) {
  const s = sessionStore.get();
  if (!s || s.activeBusinessId === businessId) return;
  queryClient.clear();
  sessionStore.set({ ...s, activeBusinessId: businessId });
}

export function clearSession() {
  sessionStore.set(null);
  queryClient.clear();
}
